import { Button, getCanvas, imageAssets, initPointer, Text } from "kontra";
import { Panel, proportionalPlacement } from "../helpers";

export class InitialMenu {
  private panelElements: any[] = [];
  isShowing = false;
  currentLevel: number;
  private levelText: Text;

  constructor(parent) {
    initPointer();

    const panel = new Panel(
      getCanvas(),
      0.5,
      0.8,
      proportionalPlacement({ y: .7 }),
      "rgba(0,0,0,0.5)"
    );

    const title = Text({
      text: 'Ass Mangoes',
      font: '34px future_narrow',
      color: '#1ca5fe',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .3 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    const subtitle = Text({
      text: 'from Outer Space',
      font: '20px future_narrow',
      color: '#aaa',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .33 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    this.levelText = Text({
      text: 'Level',
      font: '20px future_narrow',
      color: '#aaa',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .65 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    const cta = Text({
      text: 'Find the thicc\nimpostors!',
      font: '20px rocket_square',
      color: '#555',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .8 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    const button = Button({
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .7 }),
      anchor: { x: 0.5, y: 0.5 },
      image: imageAssets['mango'],

      text: {
        text: 'Start!',
        color: 'white',
        font: '28px rocket_square',
        anchor: { x: 0.5, y: 0.5 },
      },

      onDown() {
        this.x += 2;
        this.y += 5;
      },
      onUp() {
        this.clicked();
        this.x -= 2;
        this.y -= 5;
      }
    })
    button.clicked = parent.onButtonClick.bind(parent);
    button.text = 'Start!'

    this.panelElements.push(panel, title, subtitle, cta, button, this.levelText)
  }

  show(level) {
    this.currentLevel = level;
    this.isShowing = true;
    this.panelElements.forEach(element => element.show?.())
  }

  update() {
    if (this.isShowing) {
      this.levelText.text = `Level ${this.currentLevel}`;
      this.panelElements[4].update();
      this.panelElements.forEach(element => element.update?.())
    }
  }

  render() {
    if (this.isShowing) {
      this.panelElements.forEach(element => element.render?.())
    }
  }

}